export const CircleOutline = ({ color = 'black', ...restProps }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <g clip-path="url(#clip0_507_802)">
      <mask id="mask0_507_802" x="0" y="0" width="20" height="20">
        <path d="M0 0H20V20H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_507_802)">
        <path
          d="M10 7C11.655 7 13 8.345 13 10C13 11.655 11.655 13 10 13C8.345 13 7 11.655 7 10C7 8.345 8.345 7 10 7ZM10 6C7.79 6 6 7.79 6 10C6 12.21 7.79 14 10 14C12.21 14 14 12.21 14 10C14 7.79 12.21 6 10 6Z"
          fill={color}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_507_802">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DiamondGroup = ({ color = 'black', ...restProps }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M7.73792 6.08903C7.57499 6.25197 7.57499 6.51615 7.73792 6.67908L9.7047 8.64586C9.86764 8.8088 10.1318 8.8088 10.2948 8.64586L12.2616 6.67903C12.4245 6.5161 12.4245 6.25192 12.2616 6.08898L10.2948 4.12221C10.1319 3.95926 9.86769 3.95926 9.70475 4.12221L7.73792 6.08903Z"
      fill={color}
    />
    <path
      d="M11.3541 10.295L13.3209 12.2618C13.4838 12.4248 13.748 12.4248 13.911 12.2618L15.8778 10.295C16.0407 10.132 16.0407 9.86791 15.8778 9.70497L13.911 7.73817C13.7481 7.57523 13.4839 7.57523 13.3209 7.73817L11.3541 9.70502C11.1912 9.86796 11.1912 10.1321 11.3541 10.295Z"
      fill={color}
    />
    <path
      d="M4.1222 9.70502C3.95927 9.86796 3.95927 10.1321 4.1222 10.295L6.08898 12.2618C6.25192 12.4248 6.51609 12.4248 6.67903 12.2618L8.64586 10.295C8.80879 10.132 8.80879 9.86791 8.64586 9.70497L6.67908 7.73817C6.51614 7.57523 6.25197 7.57523 6.08903 7.73817L4.1222 9.70502Z"
      fill={color}
    />
    <path
      d="M7.73792 13.321C7.57499 13.4839 7.57499 13.7481 7.73792 13.911L9.7047 15.8778C9.86764 16.0408 10.1318 16.0408 10.2948 15.8778L12.2616 13.911C12.4245 13.748 12.4245 13.4839 12.2616 13.3209L10.2948 11.3541C10.1319 11.1912 9.86769 11.1912 9.70475 11.3541L7.73792 13.321Z"
      fill={color}
    />
  </svg>
);

export const DiamondOutlined = ({ color = 'black', ...restProps }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M9.98505 16.9963H9.98231C9.7746 16.9963 9.48489 16.9143 9.2799 16.5344C8.52283 15.1405 7.59356 13.8478 6.51398 12.6889C5.81703 11.9346 5.05176 11.2486 4.22635 10.6363C3.87651 10.3904 3.79179 9.90934 4.03777 9.5595C4.09243 9.48024 4.16349 9.41191 4.24549 9.35725C4.90417 8.89808 5.55192 8.33506 6.28166 7.58892C7.26012 6.58039 8.12379 5.46254 8.85353 4.25997C8.9246 4.14518 8.99019 4.02492 9.06125 3.8992C9.14598 3.74614 9.23617 3.58762 9.33183 3.43183C9.40563 3.32251 9.49855 3.22685 9.60514 3.15032C9.61608 3.14212 9.62428 3.13392 9.63247 3.12846L9.76913 3L9.95772 3.01093C10.2966 3.0328 10.5344 3.16945 10.7011 3.45097C10.7941 3.60675 10.8897 3.76527 10.9799 3.91833C11.2396 4.35563 11.5074 4.8066 11.7916 5.2275C12.5515 6.35354 13.4452 7.3812 14.4537 8.29133C14.7817 8.58651 15.1343 8.87075 15.4759 9.1468C15.5743 9.22606 15.6727 9.30532 15.7711 9.38731C15.9843 9.56223 16.1045 9.80548 16.0936 10.0542C16.0826 10.2947 15.9597 10.5134 15.7601 10.65C14.9921 11.1912 14.2542 11.8499 13.437 12.7245C12.3656 13.8778 11.4418 15.1624 10.6847 16.5426C10.4879 16.9171 10.1955 16.9963 9.98505 16.9963ZM4.87684 10.005C5.69951 10.6281 6.46752 11.3224 7.1672 12.0794C8.26318 13.2547 9.21157 14.5611 9.98778 15.9659C10.764 14.5748 11.7042 13.282 12.7892 12.115C13.6037 11.2431 14.3471 10.5708 15.1206 10.0105C15.0523 9.9558 14.9839 9.90114 14.9156 9.84374C14.5685 9.56223 14.2077 9.26979 13.8633 8.96094C12.8002 8.00435 11.8572 6.9193 11.0564 5.73312C10.7558 5.29036 10.4825 4.82573 10.2146 4.37749C10.149 4.26544 10.0807 4.15065 10.0124 4.03585C9.95498 4.13151 9.90032 4.22991 9.84293 4.33376C9.77186 4.46222 9.69807 4.59341 9.61881 4.7246C8.85353 5.9873 7.94614 7.15708 6.91575 8.2148C6.19147 8.95821 5.54099 9.52943 4.87684 10.005Z"
      fill={color}
    />
  </svg>
);

export const DiamondSolid = ({
  width = 36,
  height = 40,
  color = 'black',
  ...restProps
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M15.1252 9.84297C15.1588 9.89128 15.1794 9.94991 15.1794 10.0133C15.1794 10.1402 15.0996 10.2481 14.987 10.2896C14.5315 10.6125 12.094 12.4423 10.2686 15.8085C10.2326 15.8981 10.1572 15.9699 10.0623 15.9914C10.0376 15.9976 10.0128 15.9994 9.9881 15.9994C9.88822 15.9994 9.79483 15.9534 9.74298 15.8659C9.72914 15.8453 9.71824 15.8229 9.70999 15.7988C9.47312 15.3392 7.90345 12.4338 5.00097 10.2731C4.8955 10.2283 4.82184 10.1237 4.82184 10.0018C4.82184 9.9994 4.82184 9.99705 4.82184 9.99528C4.82067 9.9393 4.8351 9.88303 4.86574 9.83354C4.9005 9.77756 4.95265 9.73544 5.01275 9.71275C5.38955 9.44937 7.85543 7.64401 9.71617 4.2295C9.74504 4.0984 9.86289 4 10.0034 4C10.0612 4 10.1151 4.01679 10.1604 4.04537C10.2232 4.08072 10.2712 4.13847 10.2945 4.20829C10.4751 4.56447 12.0439 7.54267 15.02 9.74751C15.0624 9.77049 15.099 9.80319 15.1252 9.84297Z"
      fill={color}
    />
  </svg>
);

export const Dot = ({ color = 'black', ...restProps }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M10 7.5C8.61925 7.5 7.5 8.61925 7.5 10C7.5 11.3807 8.61925 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61925 11.3807 7.5 10 7.5Z"
      fill={color}
    />
  </svg>
);

export const SquareOutlined = ({ color = 'black', ...restProps }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M14.2393 14H6.76068C6.6167 14 6.5 13.8833 6.5 13.7393V6.26068C6.5 6.1167 6.6167 6 6.76068 6H14.2393C14.3833 6 14.5 6.1167 14.5 6.26068V13.7393C14.5 13.8833 14.3833 14 14.2393 14ZM7.02134 13.4786H13.9787V6.52134H7.02134V13.4786Z"
      fill={color}
    />
  </svg>
);

export const SquareRoundedSolid = ({ color = 'black', ...restProps }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M13.5599 6.44006C13.2666 6.14671 12.9133 6 12.5001 6H7.50001C7.08685 6 6.73349 6.14671 6.44007 6.44006C6.14671 6.73348 6 7.08681 6 7.49999V12.5C6 12.9131 6.14671 13.2665 6.44007 13.5599C6.73349 13.8533 7.08685 14 7.50001 14H12.5001C12.9132 14 13.2666 13.8533 13.5599 13.5599C13.8533 13.2665 14 12.9131 14 12.5V7.49999C14 7.08681 13.8533 6.73342 13.5599 6.44006Z"
      fill={color}
    />
  </svg>
);

export const SquareSolid = ({ color = 'black', ...restProps }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M13.8181 6H6.17888C6.08065 6 6 6.07946 6 6.17832V13.8221C6 13.919 6.08065 14 6.17888 14H13.8181C13.9186 14 14 13.919 14 13.8221V6.17832C14 6.07946 13.9182 6 13.8181 6Z"
      fill={color}
    />
  </svg>
);

export const VerifiedOutlined = ({ color = 'black', ...restProps }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M4.82982 8.57613C4.46001 8.85813 4 9.20917 4 9.75239C4 10.2956 4.46001 10.6467 4.82982 10.9287C4.98386 11.0321 5.12298 11.1561 5.24328 11.2974C5.23434 11.494 5.19482 11.6881 5.12611 11.8726C4.99695 12.3098 4.8361 12.854 5.14611 13.2798C5.45835 13.709 6.02878 13.7234 6.48705 13.7351C6.67983 13.7274 6.8727 13.7481 7.05943 13.7966C7.16209 13.9577 7.24049 14.133 7.2921 14.3169C7.44517 14.7524 7.6356 15.2944 8.14572 15.4602C8.2361 15.4898 8.3306 15.5049 8.42572 15.5049C8.80966 15.5049 9.16023 15.2639 9.47665 15.0466C9.63405 14.9209 9.8108 14.8215 9.99999 14.7524C10.1893 14.8215 10.3661 14.9208 10.5236 15.0466C10.9153 15.3156 11.3595 15.62 11.8545 15.4601C12.3645 15.2944 12.5549 14.7526 12.708 14.3171C12.7595 14.1341 12.837 13.9594 12.9382 13.7985C13.1256 13.7485 13.3194 13.7272 13.5131 13.7353C13.9713 13.7236 14.5418 13.7092 14.854 13.28C15.164 12.8539 15.0032 12.3098 14.874 11.8725C14.8061 11.689 14.7662 11.4963 14.7557 11.3009C14.8755 11.1577 15.0151 11.0323 15.1704 10.9286C15.54 10.6467 16 10.2956 16 9.75239C16 9.20917 15.54 8.85813 15.1702 8.57611C15.0161 8.4727 14.877 8.34864 14.7567 8.20739C14.7657 8.01074 14.8052 7.81667 14.8739 7.63221C15.003 7.19495 15.1639 6.65078 14.8539 6.22499C14.5416 5.79578 13.9712 5.7814 13.5129 5.76967C13.3202 5.77736 13.1273 5.75664 12.9406 5.70814C12.8379 5.54707 12.7595 5.37178 12.7079 5.18788C12.555 4.7524 12.3645 4.21042 11.8544 4.04463C11.3594 3.88376 10.9152 4.1894 10.5235 4.4582C10.366 4.58388 10.1893 4.68324 10.0001 4.7524C9.81084 4.68332 9.63403 4.58396 9.47659 4.4582C9.08486 4.18918 8.64052 3.88447 8.14564 4.04463C7.63564 4.2104 7.44521 4.75213 7.29214 5.18771C7.24065 5.3707 7.1631 5.54532 7.06191 5.70625C6.87459 5.75622 6.68077 5.77756 6.48705 5.76949C6.0288 5.78118 5.45837 5.79561 5.14613 6.22479C4.83612 6.65084 4.99695 7.19501 5.12613 7.63228C5.19403 7.81579 5.23391 8.00846 5.2444 8.20383C5.12467 8.34708 4.98506 8.47244 4.82982 8.57613ZM5.43639 9.37112C5.75037 9.13162 6.07505 8.88407 6.19457 8.5159C6.31786 8.13591 6.19421 7.71781 6.08519 7.34891C6.02644 7.17718 5.98621 6.99966 5.96518 6.81939C6.14528 6.78295 6.3288 6.7662 6.51254 6.76939C6.91403 6.75939 7.32932 6.74865 7.64952 6.51572C7.96651 6.28476 8.10336 5.89585 8.23557 5.5194C8.28936 5.34172 8.36278 5.17058 8.45444 5.00914C8.61521 5.08463 8.76793 5.17619 8.91027 5.28242C9.23083 5.50267 9.59425 5.75242 9.99999 5.75242C10.4057 5.75242 10.7692 5.50293 11.0897 5.28242C11.2321 5.17613 11.3849 5.08451 11.5458 5.00899C11.6375 5.17048 11.7109 5.3417 11.7646 5.51948C11.8968 5.89568 12.0336 6.28461 12.3507 6.51554C12.6709 6.74847 13.086 6.7592 13.4875 6.76947C13.6713 6.76603 13.8549 6.7828 14.035 6.81947C14.0139 6.99956 13.9737 7.17692 13.915 7.34852C13.8059 7.71765 13.6822 8.13587 13.8055 8.51574C13.9252 8.88391 14.2497 9.13146 14.5636 9.37096C14.7222 9.47947 14.8664 9.60762 14.9928 9.75239C14.8663 9.89704 14.7221 10.0252 14.5636 10.1337C14.2496 10.3732 13.9249 10.6208 13.8054 10.989C13.6821 11.369 13.8057 11.7871 13.9148 12.1559C13.9735 12.3277 14.0138 12.5052 14.0348 12.6855C13.8547 12.7219 13.6712 12.7387 13.4874 12.7355C13.0859 12.7455 12.6706 12.7562 12.3504 12.9891C12.0335 13.2201 11.8966 13.6091 11.7644 13.9855C11.7106 14.1631 11.6372 14.3343 11.5455 14.4957C11.3847 14.4202 11.232 14.3286 11.0897 14.2224C10.7692 14.0021 10.4057 13.7524 9.99999 13.7524C9.59425 13.7524 9.23083 14.0019 8.91027 14.2224C8.76787 14.3286 8.61507 14.4203 8.45423 14.4958C8.36252 14.3343 8.28911 14.1631 8.23535 13.9853C8.10314 13.6091 7.96643 13.2202 7.6493 12.9892C7.3291 12.7563 6.91395 12.7456 6.51246 12.7353C6.32869 12.7388 6.14508 12.722 5.96497 12.6853C5.98609 12.5052 6.02632 12.3279 6.08497 12.1563C6.19411 11.7871 6.31778 11.3689 6.19447 10.989C6.07501 10.6208 5.75039 10.3732 5.43655 10.1337C5.2779 10.0253 5.13365 9.89714 5.00723 9.75239C5.13371 9.60774 5.2779 9.47963 5.43643 9.37104V9.37112H5.43639Z"
      fill={color}
    />
    <path
      d="M9.37507 11.5023C9.50771 11.5025 9.63494 11.4497 9.72859 11.3558L12.2286 8.85581C12.4263 8.66304 12.4303 8.34648 12.2376 8.14877C12.0448 7.95104 11.7282 7.94702 11.5305 8.1398C11.5275 8.14275 11.5245 8.14574 11.5215 8.14877L9.37507 10.2953L8.4786 9.39878C8.28583 9.20107 7.96927 9.19705 7.77156 9.38983C7.57384 9.5826 7.56983 9.89916 7.7626 10.0969C7.76555 10.0999 7.76854 10.1029 7.77156 10.1058L9.02155 11.3558C9.11518 11.4497 9.24243 11.5025 9.37507 11.5023Z"
      fill={color}
    />
  </svg>
);

export const VerifiedSolid = ({ color = 'black', ...restProps }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M15.3925 8.77305C15.2319 8.66518 15.0868 8.53578 14.9613 8.38846C14.9706 8.18334 15.0118 7.98092 15.0835 7.78851C15.2182 7.33244 15.386 6.76485 15.0627 6.32073C14.737 5.87306 14.142 5.85804 13.664 5.84581C13.4629 5.85384 13.2618 5.83222 13.067 5.78164C12.9599 5.61365 12.8781 5.43081 12.8243 5.239C12.6648 4.78478 12.4661 4.21946 11.9341 4.04655C11.4178 3.87876 10.9544 4.19756 10.5459 4.47793C10.3817 4.60902 10.1973 4.71264 10 4.78478C9.80258 4.71272 9.61816 4.60908 9.45394 4.47793C9.04535 4.19732 8.58188 3.87951 8.06571 4.04655C7.53377 4.21946 7.33515 4.7845 7.17549 5.23882C7.12177 5.42968 7.0409 5.61183 6.93536 5.77968C6.73997 5.83181 6.53782 5.85405 6.33577 5.84565C5.8578 5.85786 5.26283 5.8729 4.93714 6.32054C4.6138 6.76493 4.78155 7.33252 4.91628 7.78861C4.98711 7.98 5.0287 8.18097 5.03965 8.38475C4.91474 8.53417 4.76909 8.66493 4.60713 8.77307C4.22149 9.06718 3.7417 9.43334 3.7417 9.99994C3.7417 10.5665 4.22149 10.9327 4.60723 11.2268C4.7679 11.3347 4.913 11.4641 5.03847 11.6114C5.02916 11.8165 4.98793 12.019 4.91626 12.2114C4.78155 12.6674 4.61378 13.2351 4.93712 13.6792C5.2628 14.1268 5.85777 14.1418 6.33577 14.1541C6.53684 14.146 6.738 14.1677 6.93277 14.2182C7.03986 14.3862 7.12164 14.5691 7.17546 14.7609C7.33512 15.2152 7.53374 15.7804 8.06582 15.9534C8.16009 15.9843 8.25866 16 8.35787 16C8.75831 16 9.12397 15.7487 9.45401 15.522C9.6182 15.3909 9.80254 15.2872 9.99988 15.2151C10.1973 15.2872 10.3818 15.3908 10.546 15.522C10.9545 15.8026 11.4179 16.1201 11.9342 15.9533C12.4661 15.7804 12.6648 15.2154 12.8244 14.7611C12.8781 14.5702 12.959 14.388 13.0645 14.2202C13.2599 14.1681 13.4621 14.1458 13.6641 14.1542C14.1421 14.142 14.7371 14.127 15.0628 13.6793C15.3861 13.235 15.2183 12.6674 15.0836 12.2113C15.0128 12.0199 14.9712 11.8189 14.9603 11.6151C15.0852 11.4657 15.2308 11.3349 15.3928 11.2268C15.7783 10.9327 16.2581 10.5665 16.2581 9.99994C16.2581 9.43334 15.7783 9.06718 15.3925 8.77305ZM12.3243 9.06489L9.71673 11.6725C9.66831 11.7209 9.61083 11.7593 9.54756 11.7855C9.48429 11.8117 9.41647 11.8252 9.34799 11.8252C9.27951 11.8252 9.21169 11.8117 9.14842 11.7855C9.08515 11.7593 9.02767 11.7209 8.97925 11.6725L7.67546 10.3687C7.62603 10.3205 7.58666 10.2629 7.55963 10.1994C7.5326 10.1359 7.51846 10.0676 7.51802 9.99857C7.51759 9.92953 7.53086 9.86109 7.55708 9.79722C7.5833 9.73335 7.62194 9.67532 7.67076 9.6265C7.71958 9.57768 7.77761 9.53904 7.84148 9.51282C7.90535 9.4866 7.97379 9.47332 8.04283 9.47376C8.11187 9.4742 8.18014 9.48834 8.24367 9.51537C8.30721 9.54239 8.36474 9.58177 8.41294 9.6312L9.34799 10.5663L11.5868 8.32741C11.635 8.27798 11.6926 8.23861 11.7561 8.21158C11.8196 8.18455 11.8879 8.17041 11.9569 8.16997C12.026 8.16953 12.0944 8.18281 12.1583 8.20903C12.2222 8.23525 12.2802 8.27389 12.329 8.32271C12.3778 8.37153 12.4165 8.42956 12.4427 8.49343C12.4689 8.5573 12.4822 8.62574 12.4817 8.69478C12.4813 8.76382 12.4672 8.83209 12.4401 8.89562C12.4131 8.95916 12.3737 9.01669 12.3243 9.06489Z"
      fill={color}
    />
  </svg>
);
